import { Observable, BehaviorSubject, of as observableOf } from 'rxjs';
import { mergeMap, catchError, share } from "rxjs/operators";
import { addProvider, IProviderDescriptor } from "../ServiceUtil";
import { ImmigrationDelegate } from "./immigration.delegate";
import { AuthenticationService } from "../AuthenticationService";
import { IImmigration, IImmigrationResponse, INewImmigration, INewEmployeeI9Document } from "./immigration.interface";

export class ImmigrationService
{
  
    private immigrationData: IImmigration[] = null;
    private immigrationSubject: BehaviorSubject<IImmigration[]> = new BehaviorSubject(null);
    public immigrations: Observable<IImmigration[]> = this.immigrationSubject;


    private selectedImmigrationData: IImmigration = null;
    private selectedImmigrationSubject: BehaviorSubject<IImmigration> = new BehaviorSubject(null);
    public selectedImmigration: Observable<IImmigration> = this.selectedImmigrationSubject;


    private immigrationFilteredSubject: BehaviorSubject<IImmigration[]> = new BehaviorSubject(null);
    public immigrationsFiltered: Observable<IImmigration[]> = this.immigrationFilteredSubject;

    private selectedEmployeeI9andEverifyId: string = '0';

    constructor(private immigrationDelegate: ImmigrationDelegate, private authenticationService: AuthenticationService)
    {
    }

    public get EmployeeI9andEverifyId(): string
    {
        return this.selectedEmployeeI9andEverifyId;
    }

    public getSelectedEmployeeI9andEverifyData(): IImmigration
    {
        return this.immigrationData.find((immigrationDataItem: IImmigration) =>
            immigrationDataItem.employeeI9andEverifyId ===
            this.selectedEmployeeI9andEverifyId);
    }

    public setSelectedImmigrationId(employeeI9andEverifyId: string): void
    {
        this.selectedEmployeeI9andEverifyId = employeeI9andEverifyId;
    }

    public getAllImmigration(filterEmployee: string = 'all', filterCode: string = 'all'): Observable<boolean>
    {
        const orgId = this.authenticationService.GetOrgId();
        const response = this.immigrationDelegate.getAllEmployeeI9AndEVerfiy(orgId, filterEmployee, filterCode);
        return this.processImmigrationList(response);
    }

    public getImmigrationById(immigrationId: string): Observable<boolean>
    {
        if (immigrationId === "0")
        {
            this.selectedImmigrationData = null;
            this.selectedImmigrationSubject.next(this.selectedImmigrationData);
            return observableOf(false);
        }
        var response = this.immigrationDelegate.getEmployeeI9AndEVerfiyById(immigrationId);

        return this.processImmigration(response);


    }

    public createNewImmigration(immigration: INewImmigration): Observable<boolean>
    {
        var response = this.immigrationDelegate.createNewImmigration({
            ...immigration,
            ...this.authenticationService.getBaseRequest
        });
        return this.processImmigrationList(response);
    }

    public updateImmigration(immigration: IImmigration): Observable<boolean>
    {
        var response = this.immigrationDelegate.updateImmigration({
            ...immigration,
            ...this.authenticationService.getBaseRequest
        });
        return this.processImmigrationList(response);
    }

    public createNewContractDocuments(contractDocuments: INewEmployeeI9Document): Observable<boolean>
    {
        const response = this.immigrationDelegate.createI9Contracts({
            ...contractDocuments,
            ...this.authenticationService.getBaseRequest
        });
        return this.processImmigrationList(response);
    }

    public updateContractDocuments(contractDocuments: INewEmployeeI9Document): Observable<boolean>
    {
        const response = this.immigrationDelegate.updateI9Contracts({
            ...contractDocuments,
            ...this.authenticationService.getBaseRequest
        });
        return this.processImmigrationList(response);
    }

    private processImmigrationList(immigrationResponse: Observable<IImmigrationResponse>): Observable<boolean>
    {
        immigrationResponse.subscribe(onSuccess.bind(this), onFault.bind(this));

        return immigrationResponse.pipe(mergeMap((response: any) => !response ? observableOf(false) : observableOf(true)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(immigrationResponse: IImmigrationResponse)
        {
            if (immigrationResponse.success)
            {
                this.selectedEmployeeI9andEverifyId =
                    immigrationResponse.employeeI9andEverifyId ?
                        immigrationResponse.employeeI9andEverifyId :
                        this.selectedEmployeeI9andEverifyId;

                this.immigrationData = immigrationResponse.immigrations;
                this.immigrationSubject.next(this.immigrationData);
                this.immigrationFilteredSubject.next(this.immigrationData);
            }
        }

        function onFault(error: any)
        {
            //  ImmigrationService.logger.error(`processImmigrationList Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processImmigration(immigrationResponse: Observable<IImmigrationResponse>): Observable<boolean>
    {
        immigrationResponse.subscribe(onSuccess.bind(this), onFault.bind(this));

        return immigrationResponse.pipe(mergeMap((response: any) => !response ? observableOf(false) : observableOf(true)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(immigrationResponse: IImmigrationResponse)
        {
            if (immigrationResponse.success)
            {
                this.selectedEmployeeI9andEverifyId =
                    immigrationResponse.employeeI9andEverifyId ?
                        immigrationResponse.employeeI9andEverifyId :
                        this.selectedEmployeeI9andEverifyId;

                this.selectedImmigrationData = immigrationResponse.immigration;
                this.selectedImmigrationSubject.next(this.selectedImmigrationData);
            }
        }

        function onFault(error: any)
        {
            //  ImmigrationService.logger.error(`processImmigrationList Fault - Error (${JSON.stringify(error)})`);
        }
    }

    public filterI9Data(searchTerm: string, filterBy: string)
    {
        let data = this.immigrationData;
        if (filterBy == null)
        {
            data = this.immigrationData.filter(x =>
                x.employeeFullName.trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
                || (x.everifyCaseNumber && x.everifyCaseNumber.trim().toLowerCase().includes(searchTerm.trim().toLowerCase()))
            );
        }
        else 
        {
            data = this.immigrationData.filter(x =>
                x[filterBy].trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
            );
        }

        this.immigrationFilteredSubject.next(data);
    }
}